// 品牌颜色映射 - 优化颜色对比度，确保品牌间易于区分
const BRAND_COLORS = [
  "#1890ff", // 蓝色 - 理想
  "#52c41a", // 绿色 - 蔚来
  "#ff4d4f", // 红色 - 比亚迪
  "#fa8c16", // 橙色 - 小鹏
  "#722ed1", // 紫色 - 特斯拉
  "#13c2c2", // 青色
  "#eb2f96", // 粉色
  "#f5222d", // 深红
  "#fadb14", // 黄色
  "#2f54eb", // 深蓝
];

export interface BrandComparisonChartSeries {
  name: string;
  values: number[];
  color: string;
  isCurrentBrand: boolean;
}

export interface TransformedBrandComparisonData {
  xLabels: string[];
  series: BrandComparisonChartSeries[];
  brands: Array<{
    brandId: string;
    brandName: string;
    color: string;
    isCurrentBrand: boolean;
  }>;
}

export function transformBrandComparisonData(
  rawData: any,
  currentMetric: string = "mentionRate"
): TransformedBrandComparisonData {
  if (!rawData || !rawData.brandList || !rawData.rateList) {
    return { xLabels: [], series: [], brands: [] };
  }

  const { brandList, rateList } = rawData;
  const currentBrand = brandList.curBrand;
  const otherBrands = brandList.otherBrands || [];

  // 获取当前指标的数据
  const metricData = rateList[currentMetric] || {};

  // 检查当前品牌数据是否存在
  const currentBrandData = metricData[currentBrand.brandId] || [];

  // 获取时间标签（从当前品牌数据中提取）
  const xLabels = currentBrandData.map((item: any) => item.day);

  // 构建系列数据
  const series: BrandComparisonChartSeries[] = [];
  const brands: Array<{
    brandId: string;
    brandName: string;
    color: string;
    isCurrentBrand: boolean;
  }> = [];

  // 添加当前品牌
  const currentBrandValues = currentBrandData.map((item: any) => item.rate);
  series.push({
    name: currentBrand.brandName,
    values: currentBrandValues,
    color: BRAND_COLORS[0],
    isCurrentBrand: true,
  });
  brands.push({
    brandId: currentBrand.brandId,
    brandName: currentBrand.brandName,
    color: BRAND_COLORS[0],
    isCurrentBrand: true,
  });

  // 添加竞品
  otherBrands.forEach((brand: any, index: number) => {
    const brandData = metricData[brand.brandId] || [];
    const values = brandData.map((item: any) => item.rate);
    const color = BRAND_COLORS[(index + 1) % BRAND_COLORS.length];

    series.push({
      name: brand.brandName,
      values,
      color,
      isCurrentBrand: false,
    });
    brands.push({
      brandId: brand.brandId,
      brandName: brand.brandName,
      color,
      isCurrentBrand: false,
    });
  });

  return { xLabels, series, brands };
}
